"use client";
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";

export default function Elements() {
	return (
		<div className="cpr_container">
			<div className="cpr_content">
				<div className="cpr_content_inner">

					<div className="container pt-5">
						<div className="pt-5 mt-5">
							<h3 className="mb-3">Status Labels</h3>
							<div className="pt-3 pb-3">
								<div className="label label--forsale">Active</div>
								<br /><br />
								<div className="label label--undercontract ">Under Contract - OP</div>
								<br /><br />
								<div className="label label--undercontract">Under Contract – PS</div>
								<br /><br />
								<div className="label label--undercontract">Under Contract – P</div>
								<br /><br />
								<div className="label label--sold">Sold/Rented</div>
								<br /><br />
							</div>
						</div>




						<div className="pt-5 mt-5 pb-5 mb-5">
							<h3 className="mb-3">View More Properties</h3>

							{/* Empty Card to view more */}
							<div className="cardv2 cardv2--portrait mb-0 h-100 empty_card cursor--pointer">
								<div>view more properties</div>
							</div>

						</div>


					</div>

				</div>
			</div>


			{/* 
		property overlay start here 
		Note: when implementing plz remove inline style display:block 
		*/}
			<div className="property_overlay" style={{ display: 'block' }}>
				<div className="property_window">
					<div className="pw_header d-flex mb-1">
						<div className="d-flex p-3">
							<a
								className="btn btn--icon--borderless btn--icon cmd--fav btn--icon--favorite mr-3"
								title=""
								style={{ width: "auto" }}
							/>
							<div className="dropdown dropdown--custom dropdown--custom_mediumfloat-right">
								<a
									className="text-decoration-none font_size--medium hover-opacity hover--color-auxiliary color_auxiliary pl-3 pr-2"
									href="#"
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<img
										alt="more"
										src="https://content.harstatic.com/media/icons/dot_dot_dot.svg"
									/>
								</a>
								<div
									className="dropdown-menu dropdown-menu-right"
									aria-labelledby="dropdownMenuLink"
									x-placement="bottom-end"
								>
									<a
										className="dropdown-item"
									>
										Share
									</a>
									<a
										className="cmd--notint dropdown-item"
										data-lid={9216607}
									>
										Not interested
									</a>
									<div className="dropdown-divider" />
									<a className="dropdown-item pt-3 pb-3" target="_blank" href="#">
										Print with MLS Subscriber Information
									</a>
									<a className="dropdown-item pt-3 pb-3" target="_blank" href="#">
										Printable Flyer (Primary Photo)
									</a>
									<a className="dropdown-item pt-3 pb-3" target="_blank" href="#">
										Printable Flyer (Multiple Photos)
									</a>
									<a className="dropdown-item pt-3 pb-3" target="_blank" href="#">
										Print Flyer for Consumer or Buyer
									</a>
									<a className="dropdown-item pt-3 pb-3" target="_blank" href="#">
										Print Simplified Flyer
									</a>
								</div>
							</div>
						</div>
						<a className="ml-auto m-3 close_prop_win" href="#">
							<img src="https://content.harstatic.com/media/icons/close_black.svg" />
						</a>
					</div>
					<div
						className="border_radius--default bg--image mx-3"
						style={{
							backgroundImage:
								'url("https://photos.harstatic.com/356355127/hr/img-1.jpeg?ts=2024-10-11T09:20:48.147")',
							paddingBottom: "60%"
						}}
					/>
					<div className="border-bottom border-color--cloudy-sky-light m-3 pb-3">
						<div
							className="font_size--large_extra font_weight--semi_bold color_carbon mb-0"
							tabIndex={0}
						>
							7 River Hollow Ln
						</div>
						<div className="d-flex align-items-center">
							<div className="mr-3 font_size--medium">Houston, TX 77027</div>
							<a href="#" className=" font_size--medium">
								Directions
							</a>
							<div className="ml-auto">
								<span className="bg_color_cloudy_sky_light border_radius--round font_size--small px-2 py-1 mr-1">
									222
								</span>
								<span className="color_har_blue">Days on HAR</span>
							</div>
						</div>
					</div>
					<div className="d-flex border-bottom border-color--cloudy-sky-light m-3 pb-3">
						<div>
							<div className="font_size--large font_weight--semi_bold">
								$ 1,705,000
							</div>
							<div className="font_size--medium pt-2">Est. Mortgage $2,341/mo</div>
						</div>
						<div className="ml-auto text-right">
							<div className="d-flex">
								<div className="label label--forsale_type no-wrap">For Sale</div>
								<div className="label label--forsale no-wrap">Active</div>
							</div>
							<a href="#" className="d-inline-flex ml-auto font_size--medium mt-2 ml-auto">
								<span className="mr-2">See more</span>
								<img src="https://content.harstatic.com/media/icons/arrow-right.svg" />
							</a>
						</div>
					</div>
					<div className="font_size--large px-3 pb-3">
						5 beds · 5 baths &amp; 2 half · Single Family · 2 stories · 7,551 built
						sqft · 1932 year built
					</div>
					<div className="d-flex flex-wrap px-3 pb-3">
						<div className="label label--openhouse_simple mb-2 mr-2">
							<img src="https://content.harstatic.com/media/icons/icon-open-house.svg" />
							Open House
						</div>
						<div className="label label--justlisted mb-2 mr-2">
							<img src="https://content.harstatic.com/media/icons/icon-just-listed.svg" />
							Just listed
						</div>
						<div className="label label--newconstruction mb-2 mr-2">
							<img src="https://content.harstatic.com/media/icons/icon-new-construction.svg" />
							New construction
						</div>
						<div className="label label--foreclosure mb-2 mr-2">
							<img src="https://content.harstatic.com/media/icons/icon-foreclosure.svg" />
							Foreclosure
						</div>
					</div>

					<div
						className="priceReducedContent mx-3 mb-3"
						style={{ border: "1px solid rgb(168, 0, 195) !important" }}
					>
						<div className="row no-gutters">
							<div className="col font_size--medium">
								<div className="label label--pricereduction">
									<img src="https://content.harstatic.com/media/icons/icon-price-reduction.svg" />
									Price Change
								</div>
							</div>
							<div className="col-auto pt-1 font_size--medium">
								<div className="font_size--small font_weight--regular">
									Last reduced: Sep. 21st, 2024
								</div>
							</div>
						</div>
						<div className="row no-gutters">
							<div className="col">
								<div className="font_size font_size--medium mt-3">Reduction of</div>
								<div className="font_size font_size--large font_weight font_weight--semi_bold  mt-1">
									$40,000 (4.0%)
								</div>
							</div>
							<div className="col-auto text-right">
								<div className="font_size font_size--medium mt-3">Previous Price</div>
								<div className="font_size font_size--large font_weight font_weight--semi_bold  mt-1">
									$1,000,000
								</div>
							</div>
						</div>
					</div>

					<div className=" pt-4 mx-3 border-top border-color--cloudy-sky-light">
						<h3 className="listheading mb-3" data-standardtxt="About this property" data-altheading="About this property">About this property</h3>
						<div>
							<div className="highlight-featured mb-2 box--orange">
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Quartz Countertops
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									New Appliances
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Luxury Vinyl Flooring
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Upgraded Bathrooms
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									New Roof
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									New A/C System
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Abundant Natural Light
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Spacious Living Areas
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Cul-de-sac Location
								</a>
								<a
									data-toggle="tooltip"
									data-placement="bottom"
									title="View photo"
									className="d-inline-block border_radius--default pt-2 pb-2 pl-3 pr-3 bg_color_har_blue_light_extra  hover_bg_color_har_blue_light font_size--small font_weight--semi_bold color_black text-decoration-none mb-2 mr-1"
								>
									Move-in-ready
								</a>
							</div>
						</div>


						<p className="font_size--medium mb-3">
							Nestled on a peaceful cul-de-sac, this fully remodeled 3-bedroom, 2-bath home
							effortlessly combines charm with modern elegance. Step inside to discover
							abundant natural light highlighting brand-new luxury vinyl flooring
							throughout. The beautifully renovated kitchen features exquisite quartz
							countertops and new appliances, while the refreshed bedrooms provide comfort
							and style. The kitchen flows seamlessly into the spacious living and dining
							areas, perfect for both daily living and entertaining guests. Enjoy peace of
							mind with all-new electrical and plumbing fixtures, upgraded bathrooms, a new
							A/C system, and a new roof. This move-in-ready gem offers the perfect blend of
							style, comfort, and reliability—ideal for families, first-time buyers, or
							savvy investors seeking turnkey value. Call for a private tour today!
						</p>

					</div>

					<div className=" pt-4 mx-3 border-top border-color--cloudy-sky-light">
						<h3 className="listheading mb-3" data-standardtxt="Exterior" data-altheading="Exterior">Exterior</h3>
						<div className="row">
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Roof</div>
								<div className="font_size--large text-break">Composition</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Foundation</div>
								<div className="font_size--large text-break">Slab</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Private Pool</div>
								<div className="font_size--large text-break">No</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">
									Exterior Type
								</div>
								<div className="font_size--large text-break">Brick, Stone, Wood</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">
									Lot Description
								</div>
								<div className="font_size--large text-break">Cul-De-Sac</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Water Sewer</div>
								<div className="font_size--large text-break">Water District</div>
							</div>
						</div>
					</div>

					<div className=" pt-4 mx-3 border-top border-color--cloudy-sky-light">
						<h3 className="listheading mb-3" data-standardtxt="Interior" data-altheading="Interior">Interior</h3>
						<div className="row">
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Fireplace</div>
								<div className="font_size--large text-break">1</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Floors</div>
								<div className="font_size--large text-break">Vinyl</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">
									Bedroom Description
								</div>
								<div className="font_size--large text-break">All Bedrooms Down</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">
									Room Description
								</div>
								<div className="font_size--large text-break">
									1 Living Area, Formal Dining
								</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Cooling</div>
								<div className="font_size--large text-break">Central Electric</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Heating</div>
								<div className="font_size--large text-break">Central Gas</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Dishwasher</div>
								<div className="font_size--large text-break">Yes</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Disposal</div>
								<div className="font_size--large text-break">Yes</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Microwave</div>
								<div className="font_size--large text-break">Yes</div>
							</div>
						</div>
					</div>

					<div className=" pt-4 mx-3 border-top border-color--cloudy-sky-light">
						<h3 className="listheading mb-3" data-standardtxt="Rooms" data-altheading="Rooms">Rooms</h3>
						<div className="row">
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">
									Primary Bedroom
								</div>
								<div className="font_size--large text-break">
									<span className="ftin">13</span>
									<span className="metric" style={{ display: "none" }}>
										3.96
									</span>{" "}
									x <span className="ftin">13</span>
									<span className="metric" style={{ display: "none" }}>
										3.96(m)
									</span>
									, 1st
								</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Bedroom</div>
								<div className="font_size--large text-break">
									<span className="ftin">11</span>
									<span className="metric" style={{ display: "none" }}>
										3.35
									</span>{" "}
									x <span className="ftin">10</span>
									<span className="metric" style={{ display: "none" }}>
										3.05(m)
									</span>
									, 1st
								</div>
							</div>
							<div className="col-6 mb-4">
								<div className="font_weight--bold font_size--small_extra">Bedroom</div>
								<div className="font_size--large text-break">
									<span className="ftin">11</span>
									<span className="metric" style={{ display: "none" }}>
										3.35
									</span>{" "}
									x <span className="ftin">11</span>
									<span className="metric" style={{ display: "none" }}>
										3.35(m)
									</span>
									, 1st
								</div>
							</div>
						</div>

					</div>

					<div
						className="position-sticky bg_color_snow_white p-3"
						style={{ bottom: 0 }}
					>
						<div className="row small-gutters">
							<div className="col-6">
								<a href="#" className="btn btn--primary btn--large w-100">
									View Details
								</a>
							</div>
							<div className="col-6">
								<a href="#" className="btn btn--ordinary btn--large w-100">
									Chat
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* property overlay closed here */}
		</div>
	);
}
